import { IPlanificationProgressChart } from '@sdk/contracts';
import { useTranslation } from 'react-i18next';

import { ProgressTipWrapper } from './ProgressTip.styles';

import { Icon } from '@/components/Icon';

type Props = {
  planificationProgress: IPlanificationProgressChart;
};

export const ProgressTip: React.FC<Props> = ({ planificationProgress }) => {
  const { t } = useTranslation('StudentDashboardTranslations');

  const getMessage = () => {
    const diff = planificationProgress.idealProgress - planificationProgress.currentProgress;

    if (diff < 0) {
      return t('EXCEEDED_PROGRESS_TIP', { percentage: Math.abs(diff).toFixed(1) });
    }
    if (diff === 0) {
      return t('ON_TIME_PROGRESS_TIP');
    }
    if (diff <= 10) {
      return t('BIT_LATE_PROGRESS_TIP');
    }
    return t('LATE_PROGRESS_TIP');
  };

  return (
    <ProgressTipWrapper>
      <Icon i="Information" size={14} color={'black9'} />
      <span>{getMessage()}</span>
    </ProgressTipWrapper>
  );
};
